"use client"

import React from "react"
import { useLocation, useNavigate } from "react-router"
import "./Menu.css"
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { __constants, __permissionsObj } from "../../constants"
import { useEffect } from "react"

const routingMap = {
  "/users/seekers-listing": "11",
  "/users/baby-sitters-listing": "12",
  "/users/house-keepers-listing": "13",
  "/users/review-listing": "14",
  "/users/chat-logs": "15",
  "/app/seeker": "21",
  "/app/seeker/needs": "211",
  "/app/house-keeper/available-for": "221",
  "/app/house-keeper/happy-with": "222",
  "/app/house-keeper/experience": "223",
  "/app/house-keeper/assets": "224",
  "/app/baby-sitter/have": "231",
  "/app/baby-sitter/available-for": "232",
  "/app/baby-sitter/happy-with": "233",
  "/app/baby-sitter/specialities": "234",
  "/app/baby-sitter/experience": "235",
  "/app/baby-sitter/children": "236",
  "/app/help&support/categories": "241",
  "/booking/job-posted": "31",
  "/booking/job-posted/appliers": "31",
  "/booking/bookings": "32",
  "/role": "41",
  "/role/sub-admin": "42",
  "/scope/available-cities": "51",
  "/scope/available-areas": "52",
  "/scope/nona-fees": "53",
  "/scope/promo-code": "54",
  "/general-settings/terms-condition": "61",
  "/general-settings/policy-page": "62",
  "/general-settings/disclaimer": "63",
  "/general-settings/cancel-policy": "64",
  "/payments/user": "71",
  "/payments/withdraw": "72",
  "/invoice-disputes": "73",
  "/faqs": "80",
  "/faqs/customer": "81",
  "/faqs/housekeeper": "82",
  "/faqs/babysitter": "83",
  "/help&support": "91",
  "/reports": "92",
  "/notifications": "100",
  "/notifications/history": "101",
  "/notifications/send": "102",
  "/notifications/scheduled": "103",
}

const Menu = ({ loginUserDetails, setLoginUserDetails }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [state, setState] = React.useState({ expanded: [], selected: null })
  const { pathname } = location
  const isActive = (path) => pathname === path ? "menu_active_link" : "menu_inactive_link"
  const includesActive = (path) => pathname.includes(path) ? "menu_active_link" : "menu_inactive_link"
  const { managerPermission, role } = loginUserDetails
  const isAdmin = role === "Admin"

  const handleLogOut = () => {
    setLoginUserDetails({})
    localStorage.removeItem(__constants.authToken)
    navigate("/login")
  }

  useEffect(() => {
    localStorage.setItem("currentPath", location.pathname + location.search)
    handleOpenDefaultOpen()
  }, [location.pathname, location.search])

  const handleOpenDefaultOpen = () => {
    if (pathname === "/") {
      setState({ expanded: ["0"], selected: "0" })
    } else if (pathname.includes("/users")) {
      setState({ expanded: ["1"], selected: routingMap[pathname] || "1" })
    } else if (pathname.includes("/app")) {
      if (pathname.includes("/app/seeker")) {
        setState({ expanded: ["2", "21"], selected: routingMap[pathname] || "21" })
      } else if (pathname.includes("/app/house-keeper")) {
        setState({ expanded: ["2", "22"], selected: routingMap[pathname] || "22" })
      } else if (pathname.includes("/app/baby-sitter")) {
        setState({ expanded: ["2", "23"], selected: routingMap[pathname] || "23" })
      } else if (pathname.includes("/app/help&support/categories")) {
        setState({ expanded: ["2", "24"], selected: routingMap[pathname] || "24" })
      } else {
        setState({ expanded: ["2"], selected: "2" })
      }
    } else if (pathname.includes("/booking")) {
      if (pathname.includes("/booking/job-posted")) {
        setState({ expanded: ["3"], selected: "31" })
      } else if (pathname.includes("/booking/bookings")) {
        setState({ expanded: ["3"], selected: "32" })
      } else {
        setState({ expanded: ["3"], selected: "3" })
      }
    } else if (pathname.includes("/role")) {
      setState({ expanded: ["4"], selected: routingMap[pathname] || "4" })
    } else if (pathname.includes("/scope")) {
      setState({ expanded: ["5"], selected: routingMap[pathname] || "5" })
    } else if (pathname.includes("/general-settings")) {
      setState({ expanded: ["6"], selected: routingMap[pathname] || "6" })
    } else if (pathname.includes("/payment")) {
      setState({ expanded: ["7"], selected: routingMap[pathname] || "7" })
    } else if (pathname.includes("/faqs")) {
      const faqMap = { "/faqs/customer": "81", "/faqs/housekeeper": "82", "/faqs/babysitter": "83" }
      setState({ expanded: ["8"], selected: faqMap[pathname] || "80" })
    } else if (pathname === "/help&support") {
      setState({ expanded: ["9"], selected: "91" })
    } else if (pathname === "/reports") {
      setState({ expanded: ["9"], selected: "92" })
    } else if (pathname.includes("/notifications") || pathname === "/Notification") {
      const notifMap = { "/notifications/send": "102", "/notifications/scheduled": "103" }
      setState({ expanded: ["100"], selected: notifMap[pathname] || "101" })
    }
  }

  useEffect(() => {
    if (!state.selected) {
      const savedPath = localStorage.getItem("currentPath")
      if (savedPath) {
        console.log("Restoring menu state from saved path:", savedPath)
        handleOpenDefaultOpen()
      }
    }
  }, [state.selected])

  const TreeItemComponent = ({ itemId, label, onClick, className, children }) => (
    <TreeItem itemId={itemId} label={label} onClick={onClick} className={className}>
      {children}
    </TreeItem>
  )

  const hasPermission = (permission) => managerPermission.includes(permission) || isAdmin

  return (
    <div className="menu_main_div menu_active">
      <div className="menu_logo">
        <img src="/assets/logo_white.svg" alt="" />
      </div>
      <h6>MENU</h6>
      <div className="menu_list">
        <ul>
          <li></li>
          {state.selected && (
            <ul className={isActive("/")}>
              <SimpleTreeView
                expanded={state.expanded}
                selected={[state.selected]}
                aria-label="file system navigator"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                sx={{ flexGrow: 1, overflowY: "auto" }}
              >
                {/* Dashboard */}
                {hasPermission(__permissionsObj.Dashboard) && (
                  <TreeItemComponent itemId="0" label="Dashboard" onClick={() => navigate("/")} className={isActive("/")} />
                )}

                {/* Users */}
                {(hasPermission(__permissionsObj.Seeker) || hasPermission(__permissionsObj.HouseKeeper) || hasPermission(__permissionsObj.BabySitter)) && (
                  <TreeItemComponent itemId="1" label="User management" className={includesActive("/users")}>
                    {hasPermission(__permissionsObj.Seeker) && (
                      <TreeItemComponent itemId="11" label="Customer" onClick={() => navigate("users/seekers-listing")} className={isActive("/users/seekers-listing")} />
                    )}
                    {hasPermission(__permissionsObj.BabySitter) && (
                      <TreeItemComponent itemId="12" label="Babysitter" onClick={() => navigate("users/baby-sitters-listing")} className={isActive("/users/baby-sitters-listing")} />
                    )}
                    {hasPermission(__permissionsObj.HouseKeeper) && (
                      <TreeItemComponent itemId="13" label="Housekeeper" onClick={() => navigate("users/house-keepers-listing")} className={isActive("/users/house-keepers-listing")} />
                    )}
                    {hasPermission(__permissionsObj.reviews) && (
                      <TreeItemComponent itemId="14" label="User reviews" onClick={() => navigate("users/review-listing")} className={isActive("/users/user-review")} />
                    )}
                    {hasPermission(__permissionsObj.HouseKeeper) && (
                      <TreeItemComponent itemId="15" label="User chat logs" onClick={() => navigate("users/chat-logs")} className={isActive("/users/chat-logs")} />
                    )}
                  </TreeItemComponent>
                )}

                {/* App Management */}
                {hasPermission(__permissionsObj.AppManagement) && (
                  <TreeItemComponent itemId="2" label="App management" className={includesActive("/app/")}>
                    <TreeItemComponent itemId="21" label="Customer" className={includesActive("/app/seeker")}>
                      <TreeItemComponent itemId="211" label="Needs" onClick={() => navigate("/app/seeker/needs")} className={isActive("/app/seeker/need")} />
                    </TreeItemComponent>
                    <TreeItemComponent itemId="22" label="Housekeeper" className={includesActive("/app/house-keeper")}>
                      <TreeItemComponent itemId="221" label="Availability" onClick={() => navigate("/app/house-keeper/available-for")} className={isActive("/app/house-keeper/available-for")} />
                      <TreeItemComponent itemId="222" label="Help with" onClick={() => navigate("/app/house-keeper/happy-with")} className={isActive("/app/house-keeper/happy-with")} />
                      <TreeItemComponent itemId="223" label="Experience - years" onClick={() => navigate("/app/house-keeper/experience")} className={isActive("/app/house-keeper/experience")} />
                      <TreeItemComponent itemId="224" label="Assets" onClick={() => navigate("/app/house-keeper/assets")} className={isActive("/app/house-keeper/assets")} />
                    </TreeItemComponent>
                    <TreeItemComponent itemId="23" label="Babysitter" className={includesActive("/app/baby-sitter")}>
                      <TreeItemComponent itemId="231" label="Assets" onClick={() => navigate("/app/baby-sitter/have")} className={isActive("/app/baby-sitter/have")} />
                      <TreeItemComponent itemId="232" label="Availability" onClick={() => navigate("/app/baby-sitter/available-for")} className={isActive("/app/baby-sitter/available-for")} />
                      <TreeItemComponent itemId="233" label="Help with" onClick={() => navigate("/app/baby-sitter/happy-with")} className={isActive("/app/baby-sitter/happy-with")} />
                      <TreeItemComponent itemId="234" label="Specialities" onClick={() => navigate("/app/baby-sitter/specialities")} className={isActive("/app/baby-sitters/specialities")} />
                      <TreeItemComponent itemId="235" label="Experience - years" onClick={() => navigate("/app/baby-sitter/experience")} className={isActive("/app/baby-sitter/experience")} />
                      <TreeItemComponent itemId="236" label="Experience - children" onClick={() => navigate("/app/baby-sitter/children")} className={isActive("/app/baby-sitter/children")} />
                    </TreeItemComponent>
                    <TreeItemComponent itemId="24" label="Help & Support" className={includesActive("/app/help&support/categories")}>
                      <TreeItemComponent itemId="241" label="Categories" onClick={() => navigate("/app/help&support/categories")} className={isActive("/app/house-keeper/available-for")} />
                    </TreeItemComponent>
                  </TreeItemComponent>
                )}

                {/* Booking Management */}
                {hasPermission(__permissionsObj.bookingManagement) && (
                  <TreeItemComponent itemId="3" label="Booking management" className={includesActive("/booking")}>
                    <TreeItemComponent itemId="31" label="Jobs" onClick={() => navigate("/booking/job-posted")} className={pathname === "/booking/job-posted" || pathname.includes("/booking/job-posted/appliers") ? "menu_active_link" : "menu_inactive_link"} />
                    <TreeItemComponent itemId="32" label="Bookings" onClick={() => navigate("/booking/bookings")} className={isActive("/booking/bookings")} />
                  </TreeItemComponent>
                )}

                {/* Role Management */}
                {hasPermission(__permissionsObj.RoleManagement) && (
                  <TreeItemComponent itemId="4" label="Role management" className={includesActive("/role")}>
                    <TreeItemComponent itemId="41" label="Roles" onClick={() => navigate("/role")} className={isActive("/role")} />
                    <TreeItemComponent itemId="42" label="Users" onClick={() => navigate("/role/sub-admin")} className={isActive("/role/sub-admin")} />
                  </TreeItemComponent>
                )}

                {/* Admin Only Sections */}
                {isAdmin && (
                  <>
                    {/* General Management */}
                    <TreeItemComponent itemId="5" label="General management" className={includesActive("/scope")}>
                      <TreeItemComponent itemId="51" label="Available cities" onClick={() => navigate("/scope/available-cities")} className={isActive("scope/available-cities")} />
                      <TreeItemComponent itemId="52" label="Available areas" onClick={() => navigate("/scope/available-areas")} className={isActive("scope/available-areas")} />
                      <TreeItemComponent itemId="53" label="Nona fees" onClick={() => navigate("/scope/nona-fees")} className={isActive("scope/nona-fees")} />
                      <TreeItemComponent itemId="55" label="Promo codes" onClick={() => navigate("/scope/promo-code")} className={isActive("scope/promo-code")} />
                    </TreeItemComponent>

                    {/* Legal */}
                    <TreeItemComponent itemId="6" label="Legal" className={includesActive("/general-settings")}>
                      <TreeItemComponent itemId="61" label="Terms & conditions" onClick={() => navigate("/general-settings/terms-condition")} className={isActive("general-settings/terms-condition")} />
                      <TreeItemComponent itemId="62" label="Privacy policy" onClick={() => navigate("/general-settings/policy-page")} className={isActive("general-settings/policy-page")} />
                      <TreeItemComponent itemId="63" label="Disclaimer" onClick={() => navigate("/general-settings/disclaimer")} className={isActive("general-settings/disclaimer")} />
                      <TreeItemComponent itemId="64" label="Cancel policy" onClick={() => navigate("/general-settings/cancel-policy")} className={isActive("general-settings/cancel-policy")} />
                    </TreeItemComponent>

                    {/* Payments */}
                    <TreeItemComponent itemId="7" label="Payments" className={includesActive("/payment")}>
                      <TreeItemComponent itemId="71" label="Payments" onClick={() => navigate("/payments/user")} className={isActive("payments/user")} />
                      <TreeItemComponent itemId="73" label="Payment Disputes" onClick={() => navigate("/payments/disputes")} className={isActive("/payments/disputes")} />
                    </TreeItemComponent>

                    {/* FAQ Management */}
                    <TreeItemComponent itemId="8" label="FAQ management" className={includesActive("/faqs")}>
                      <TreeItemComponent itemId="81" label="Customer FAQs" onClick={() => navigate("/faqs/customer")} className={isActive("/faqs/customer")} />
                      <TreeItemComponent itemId="82" label="Housekeeper FAQs" onClick={() => navigate("/faqs/housekeeper")} className={isActive("/faqs/housekeeper")} />
                      <TreeItemComponent itemId="83" label="Babysitter FAQs" onClick={() => navigate("/faqs/babysitter")} className={isActive("/faqs/babysitter")} />
                    </TreeItemComponent>

                    <TreeItemComponent itemId="91" label="Help & Support" onClick={() => navigate("/help&support")} className={isActive("/help&support")} />
                    <TreeItemComponent itemId="92" label="Reports" onClick={() => navigate("/reports")} className={isActive("/reports")} />

                    {/* Notification Management */}
                    <TreeItemComponent itemId="100" label="Notification Management" className={pathname.includes("/notifications") || pathname === "/Notification" ? "menu_active_link" : "menu_inactive_link"}>
                      <TreeItemComponent itemId="103" label="Custom Notifications" onClick={() => navigate("/notifications/scheduled")} className={isActive("/notifications/scheduled")} />
                    </TreeItemComponent>
                  </>
                )}

                <TreeItemComponent itemId="9" label="Log out" onClick={handleLogOut} className="menu_inactive_link" />
              </SimpleTreeView>
            </ul>
          )}
        </ul>
        <div className="menu_footer">
          <span>App Version 1.0.0</span>
          <span>&copy; 2021 All rights reserved</span>
        </div>
      </div>
    </div>
  )
}

export default Menu